module.exports = __webpack_public_path__ + "assets/img/favicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/frontend/assets/img/favicon.png
// module id = ./src/main/frontend/assets/img/favicon.png
// module chunks = 1